"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var base_1 = __importDefault(require("./base"));
var Pivx = /** @class */ (function (_super) {
    __extends(Pivx, _super);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Pivx(_a) {
        var network = _a.network;
        var _this = _super.call(this, { network: network }) || this;
        // refer to https://github.com/LedgerHQ/lib-ledger-core/blob/master/core/src/wallet/bitcoin/networks.cpp#L369
        _this.network.bip32.public = 0x022d2533;
        _this.network.pubKeyHash = 0x1e;
        _this.network.scriptHash = 0x0d;
        _this.network.dustThreshold = 10000;
        _this.network.dustPolicy = "FIXED";
        _this.network.usesTimestampedTransaction = false;
        return _this;
    }
    return Pivx;
}(base_1["default"]));
exports["default"] = Pivx;
//# sourceMappingURL=pivx.js.map